module.exports = __webpack_public_path__ + "img/bergenia.db84cf61.jpg";